const SET_CURRENT_WITHDRAW = (state, payload) => { state.currentWithdraw = payload || {} }
const RESET_CURRENT_WITHDRAW = (state) => { 
    state.currentWithdraw = {
        id: null, uuid: "", vendorId: "", vendorTax: "",
        value: 0, orders: [], created: "", processed: false,
        pixHash: null, placeUuid: "", obs: "",
        info: {
            month: "", period: { start: "", end: "", }, last_pos_cred: 0, last_online_cred: 0,
            online_cred: 0, online_deb: 0, online_pix: 0, online_wallet: 0,
            pos_cred: 0, pos_deb: 0, pos_pix: 0, local_money: 0,
            pois_tax: ""
        }
    } 
}

const SET_ATTRACTIONS_PAYMENTS_LIST = (state, payload) => {
    state.attractionsPaymentsList = payload.map((withdraw, index) => {
        if (typeof withdraw.orders == 'string') { withdraw.info = JSON.parse(withdraw.orders)[0].info }
        return withdraw
    })
}
const RESET_ATTRACTIONS_PAYMENTS_LIST = (state) => { state.attractionsPaymentsList = [] }

const SET_WITHDRAW_BOOKINGS_LIST = (state, payload) => { 
    state.withdrawBookingsList = payload.map((booking, index) => {
        if (typeof booking.payload == 'string') { booking.payload = JSON.parse(booking.payload) }
        return booking
    })
}
const RESET_WITHDRAW_BOOKINGS_LIST = (state) => { state.withdrawBookingsList = [] }

const SET_CURRENT_WITHDRAW_PAYMENTS = (state, payload) => {
    state.currentWithdraw.info = payload[0].info
    state.currentWithdraw.value = payload[0].info.value
    state.currentWithdraw.last_report_uuid = payload[0].info.ref_report_uuid
}
const RESET_CURRENT_WITHDRAW_PAYMENTS = (state) => { state.withdrawPaymentsList = [] }

const SET_IS_LOADING = (state, payload) => { state.isLoading = payload }
const RESET_IS_LOADING = (state) => { state.isLoading = false }

export default {
    SET_CURRENT_WITHDRAW,
    RESET_CURRENT_WITHDRAW,
    SET_ATTRACTIONS_PAYMENTS_LIST,
    RESET_ATTRACTIONS_PAYMENTS_LIST,
    SET_WITHDRAW_BOOKINGS_LIST,
    RESET_WITHDRAW_BOOKINGS_LIST,
    SET_CURRENT_WITHDRAW_PAYMENTS,
    RESET_CURRENT_WITHDRAW_PAYMENTS,
    SET_IS_LOADING,
    RESET_IS_LOADING,
}